import {BaseRequestResult} from './request'

/**
 * The backend answers a conflict with an envelope whose `errorType` is `CONFLICT`
 * (`HTTP_YERROR_NAME_MAP` in create_http_yerror.ts). That name does not move, so it is the
 * signal worth keying on: the numeric status is migrating from 410 to 409 (z91464gzar) and
 * the name is identical on both sides of the renumbering.
 *
 * The status numbers stay as a fallback because a bare `res.sendStatus()` sends no body, and
 * because either signal alone must be enough -- this must never recognise fewer responses
 * than the status comparison it replaced. Drop the `410` leg once the backend has deployed.
 */
export const isConflictResult = (result?: BaseRequestResult | null): boolean => {
  if (!result) return false
  return conflictErrorType(result) === 'CONFLICT' || result.statusCode === 409 || result.statusCode === 410
}

const conflictErrorType = (result: BaseRequestResult): string | undefined =>
  (result.payload as {errorType?: string} | null)?.errorType

/**
 * The backend's own words for why it refused, from the envelope's `errorHint`. It is developer
 * prose, so callers match it rather than showing it, and must stay correct when it is absent.
 */
export const conflictErrorHint = (result?: BaseRequestResult | null): string =>
  (result?.payload as {errorHint?: string} | null)?.errorHint ?? ''
